// Mặc định gọi cùng origin (npm start dùng "proxy" trong package.json để chuyển sang GServer).
// Khi build để host riêng thì đặt REACT_APP_API_URL, ví dụ http://127.0.0.1:8082
const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const TOKEN_KEY = "petrealm_admin_token";

let unauthorizedHandler = null;

export class ApiError extends Error {}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

/** remember = true: giữ qua lần mở trình duyệt sau; false: mất khi đóng tab. */
export function setToken(token, remember = true) {
  clearToken();
  (remember ? localStorage : sessionStorage).setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function onUnauthorized(handler) {
  unauthorizedHandler = handler;
}

/** Đường dẫn ảnh trong thư mục assets của GServer, ví dụ "items/100001.png". */
export function assetUrl(path) {
  return path ? `${API_BASE}/api/assets/${path.replace(/^\/+/, "")}` : null;
}

function buildUrl(path, query) {
  const params = new URLSearchParams();
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  });
  const search = params.toString();
  return `${API_BASE}${path}${search ? `?${search}` : ""}`;
}

async function request(method, path, { body, query } = {}) {
  const headers = { Accept: "application/json" };
  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const isForm = body instanceof FormData;
  if (body !== undefined && !isForm) {
    headers["Content-Type"] = "application/json";
  }

  let response;
  try {
    response = await fetch(buildUrl(path, query), {
      method,
      headers,
      body: body !== undefined && !isForm ? JSON.stringify(body) : body,
    });
  } catch (e) {
    throw new ApiError("Không kết nối được máy chủ game (GServer có đang chạy không?)");
  }

  let json = null;
  try {
    json = await response.json();
  } catch (e) {
    // Phản hồi không phải JSON, xử lý theo mã HTTP bên dưới.
  }

  // GServer tắt thì proxy của npm start trả 500/504 dạng text "Proxy error ... ECONNREFUSED", không phải JSON.
  if (!json && response.status >= 500) {
    throw new ApiError("Không kết nối được máy chủ game (GServer có đang chạy không?)");
  }
  if (response.status === 401) {
    clearToken();
    if (unauthorizedHandler) unauthorizedHandler();
    throw new ApiError(json?.data || "Phiên đăng nhập đã hết hạn");
  }
  if (response.status === 404 && path.startsWith("/api/admin")) {
    throw new ApiError(
      "GServer đang chạy bản cũ chưa có chức năng này, hãy khởi động lại GServer (phím R trong run-dev)"
    );
  }
  if (!response.ok) {
    throw new ApiError(
      (typeof json?.data === "string" && json.data) ||
        json?.title ||
        `Máy chủ trả lỗi ${response.status}`
    );
  }
  if (!json || json.status !== 1) {
    throw new ApiError(typeof json?.data === "string" ? json.data : "Thao tác thất bại");
  }
  return json.data;
}

const api = {
  get: (path, query) => request("GET", path, { query }),
  post: (path, body = {}) => request("POST", path, { body }),
  put: (path, body = {}) => request("PUT", path, { body }),
  del: (path) => request("DELETE", path),
  /** Gửi multipart/form-data, fields là object các trường (File hoặc chuỗi / số). */
  upload: (path, fields) => {
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => form.append(key, value));
    return request("POST", path, { body: form });
  },
};

export default api;
